const aiResponses = {
    "1-onboarding-activation-question": [
      "• Safe-haven currencies appreciate during uncertainty; buying Yen is optimal.",
      "• Understand the context: Forex: Yen Rally - When the Yen rallies amid global uncertainty, what should you do?",
      "• Watch for market volatility indicators like VIX or geopolitical news.",
      "• Compare Yen performance with other safe havens like USD or CHF.",
      "• Ensure stop-loss protection in case of unexpected reversal."
    ],
    "2-onboarding-activation-question": [
      "• Match each market movement with the correct trade response.",
      "• Understand the context: Forex: Match each price action with its trading response?",
      "• Use trendlines, candlestick patterns, or RSI for confirmation.",
      "• Breakouts often need volume confirmation before entry.",
      "• Reversals may need double confirmation—like MACD and RSI."
    ],
    "3-onboarding-activation-question": [
      "• Tap and hold on Candlestick, Check the last value.",
      "• Understand the context: On 19th Oct, what is the close price?",
      "• Focus on the body end of the candlestick for close values.",
      "• Cross-verify by checking chart data or OHLC display.",
      "• Always look at the correct date using chart navigation tools."
    ],
    "4-onboarding-activation-question": [
      "• A bullish crossover indicates an opportunity to buy.",
      "• Understand the context: Technical - Bullish Moving Average Crossover.",
      "• Look for confirmation through RSI or volume increase.",
      "• Short-term moving average crossing long-term suggests trend reversal.",
      "• Avoid fake signals during sideways markets—use support zones too."
    ],
    "5-onboarding-activation-question": [
      "• Match each metric with its proper investment insight.",
      "• Understand the context: Match valuation metrics with implications.",
      "• Low P/E may imply undervaluation but check for fundamental issues.",
      "• ROE measures efficiency—compare with industry benchmarks.",
      "• Dividend growth signals stability; revenue growth fuels speculation."
    ],
    "6-onboarding-activation-question8": [
      "• Tap and hold on Candlestick, open and close are close in value.",
      "• Understand the context: Doji-like candlestick—indecision in price.",
      "• This could suggest market uncertainty or trend reversal signal.",
      "• Use in combination with trendline or volume for confirmation.",
      "• Avoid acting solely on a single candle—analyze in context."
    ],
    "7-onboarding-activation-question": [
      "• Tap and hold on candlestick to compare open vs. close prices.",
      "• Understand the context: Bullish candle if close > open.",
      "• Candlestick body color can visually confirm direction.",
      "• Cross-check with previous candle for trend continuation or break.",
      "• Avoid assuming based on memory—always verify on chart."
    ],
    "8-onboarding-activation-question": [
      "• Match each tool with the correct function in risk management.",
      "• Understand the context: How tools like stop loss or trailing stop work.",
      "• Use stop loss for capital protection in volatile markets.",
      "• Trailing stops help lock in profit while staying in trend.",
      "• Risk limits prevent overexposure—especially in leverage trading."
    ],
    "9-onboarding-activation-question": [
      "• Pair each bias with the behavior it typically triggers.",
      "• Understand the context: Emotions deeply influence trade outcomes.",
      "• Overconfidence often leads to over-leveraged trades.",
      "• Fear results in early exits, missing potential profits.",
      "• Greed may push traders to chase unsustainable rallies."
    ],
    "10-onboarding-activation-question": [
      "• Historically, halving events lead to long-term price increases for Bitcoin.",
      "• Understand the context: Halving reduces mining rewards—less supply.",
      "• Use long-term charts to spot post-halving trends.",
      "• Momentum may follow hype—time your entries carefully.",
      "• Combine fundamental event with technical confirmation for action."
    ],
    "11-onboarding-activation-question": [
      "• Link each chart pattern with the corresponding market outcome.",
      "• Understand the context: Chart patterns reflect crowd psychology.",
      "• Head and Shoulders usually means trend reversal.",
      "• Triangle and Flag patterns typically suggest continuation.",
      "• Cup & Handle formation signals bullish breakout potential."
    ],
    "12-onboarding-activation-question": [
      "• A sharp pullback can indicate profit-taking; waiting for a reversal signal is safer.",
      "• Understand the context: Pullbacks may offer re-entry chances.",
      "• Watch support zones to catch trend resumption.",
      "• RSI and MACD can help confirm oversold conditions.",
      "• Avoid fear-driven decisions—wait for market stabilization."
    ],
    "13-onboarding-activation-question": [
      "• A death cross can be a bearish signal; shorting may be a defensive move.",
      "• Understand the context: 50-day MA below 200-day MA = bearish trend.",
      "• Confirm trend direction with volume and momentum indicators.",
      "• Don't panic—use technicals to assess continuation or fakeout.",
      "• Combine with broader market sentiment before reacting."
    ]
  };
  
  export default aiResponses;






//   const aiResponses = {
//     "1-onboarding-activation-question": [
//       "• Safe-haven currencies appreciate during uncertainty; buying Yen is optimal.",
//       "• Understand the context: Forex: Yen Rally - When the Yen rallies amid global uncertainty, what should you do?",
//       "• Watch for market volatility indicators like VIX or geopolitical news.",
//       "• Compare Yen performance with other safe havens like USD or CHF.",
//       "• Ensure stop-loss protection in case of unexpected reversal."
//     ],
//     "2-onboarding-activation-question": [
//       "• Match each market movement with the correct trade response.",
//       "• Understand the context: Forex: Match each price action with its trading response?",
//       "• Use trendlines, candlestick patterns, or RSI for confirmation.",
//       "• Breakouts often need volume confirmation before entry.",
//       "• Reversals may need double confirmation—like MACD and RSI."
//     ],
//     "3-onboarding-activation-question": [
//       "• Tap and hold on Candlestick,Check the last value.",
//       "• Understand the context: On 19th Oct, what is the close price?",
//       "• Focus on the body end of the candlestick for close values.",
//       "• Cross-verify by checking chart data or OHLC display.",
//       "• Always look at the correct date using chart navigation tools."
//     ],
//     "4-onboarding-activation-question": [
//       "• A bullish crossover indicates an opportunity to buy.",
//       "• Understand the context: Technical - Bullish Moving Average Crossover.",
//       "• Look for confirmation through RSI or volume increase.",
//       "• Short-term moving average crossing long-term suggests trend reversal.",
//       "• Avoid fake signals during sideways markets—use support zones too."
//     ],
//     "5-onboarding-activation-question": [
//       "• Match each metric with its proper investment insight.",
//       "• Understand the context: Match valuation metrics with implications.",
//       "• Low P/E may imply undervaluation but check for fundamental issues.",
//       "• ROE measures efficiency—compare with industry benchmarks.",
//       "• Dividend growth signals stability; revenue growth fuels speculation."
//     ],
//     "6-onboarding-activation-question8": [
//       "• Tap and hold on Candlestick, open and close are close in value.",
//       "• Understand the context: Doji-like candlestick—indecision in price.",
//       "• This could suggest market uncertainty or trend reversal signal.",
//       "• Use in combination with trendline or volume for confirmation.",
//       "• Avoid acting solely on a single candle—analyze in context."
//     ],
//     "7-onboarding-activation-question": [
//       "• Tap and hold on candlestick to compare open vs. close prices.",
//       "• Understand the context: Bullish candle if close > open.",
//       "• Candlestick body color can visually confirm direction.",
//       "• Cross-check with previous candle for trend continuation or break.",
//       "• Avoid assuming based on memory—always verify on chart."
//     ],
//     "8-onboarding-activation-question": [
//       "• Match each tool with the correct function in risk management.",
//       "• Understand the context: How tools like stop loss or trailing stop work.",
//       "• Use stop loss for capital protection in volatile markets.",
//       "• Trailing stops help lock in profit while staying in trend.",
//       "• Risk limits prevent overexposure—especially in leverage trading."
//     ],
//     "9-onboarding-activation-question": [
//       "• Pair each bias with the behavior it typically triggers.",
//       "• Understand the context: Emotions deeply influence trade outcomes.",
//       "• Overconfidence often leads to over-leveraged trades.",
//       "• Fear results in early exits, missing potential profits.",
//       "• Greed may push traders to chase unsustainable rallies."
//     ],
//     "10-onboarding-activation-question": [
//       "• Historically, halving events lead to long-term price increases for Bitcoin.",
//       "• Understand the context: Halving reduces mining rewards—less supply.",
//       "• Use long-term charts to spot post-halving trends.",
//       "• Momentum may follow hype—time your entries carefully.",
//       "• Combine fundamental event with technical confirmation for action."
//     ],
//     "11-onboarding-activation-question": [
//       "• Link each chart pattern with the corresponding market outcome.",
//       "• Understand the context: Chart patterns reflect crowd psychology.",
//       "• Head and Shoulders usually means trend reversal.",
//       "• Triangle and Flag patterns typically suggest continuation.",
//       "• Cup & Handle formation signals bullish breakout potential."
//     ],
//     "12-onboarding-activation-question": [
//       "• A sharp pullback can indicate profit-taking; waiting for a reversal signal is safer.",
//       "• Understand the context: Pullbacks may offer re-entry chances.",
//       "• Watch support zones to catch trend resumption.",
//       "• RSI and MACD can help confirm oversold conditions.",
//       "• Avoid fear-driven decisions—wait for market stabilization."
//     ],
//     "13-onboarding-activation-question": [
//       "• A death cross can be a bearish signal; shorting may be a defensive move.",
//       "• Understand the context: 50-day MA below 200-day MA = bearish trend.",
//       "• Confirm trend direction with volume and momentum indicators.",
//       "• Don't panic—use technicals to assess continuation or fakeout.",
//       "• Combine with broader market sentiment before reacting."
//     ]
//   };
  